<div class="fieldset-wrapper" [ngClass]="(questions?.mandatory && isMandatoryUpfront) ? 'isMandatory' : ''">
  <!-- <div *ngIf="questions?.hasImages && questions?.QuestionImages_1 != null" class="questionImageWrapper">
   
    <app-question-images [questionImages]="questions?.QuestionImages_1"></app-question-images>
  </div> -->
  <fieldset>
    <legend>
      <span *ngIf="questions.piping" id="lbltitle_T{{questions?.UniqueNumber}}">{{questions?.pipingQuationTitle}}</span>
      <span *ngIf="!questions.piping" class="question-text"
        id="lbltitle_R{{questions?.UniqueNumber}}" [innerHTML]="questions?.qtitle | headerFooterHtml"></span>
      <span *ngIf="questions.QuestionTip" class="tooltip_container" appTooltip [dataContext]="questions?.QuestionTip"
        [IsButtonPanel]="false"></span>
    </legend>
    <!-- <div *ngIf="questions?.hasImages && questions?.QuestionImages_2 != null">  
       <app-question-images [questionImages]="questions?.QuestionImages_2"></app-question-images>
    </div> -->

    <div [attr.data-ans-image]="answerImagesLength">
      <input type="text" [style.width]="questions?.twidth +'%'" class="ansopt-textbox" (blur)="onBlurMethod($event,$event.target.value)"
        id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID"
        name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME" [(ngModel)]="questions.AnswerText"
        (keyup)="keytab($event, $event.target.value)"
        maxlength="{{questions?.characterLimit ? questions?.characterLimit: ''}}" aria-label="textbox">

      <div *ngIf="questions?.Showcharlimit && questions?.qsubtype != 22" class="char-remain charraim">
        {{questions?.RemainingChr}}: {{remainingCharacters}}
      </div>
      <div *ngIf="questions.isValid" class="validator_message">
        {{questions.error_msg}}
      </div>
    </div>
  </fieldset>
</div>